import { useContext } from 'react';
import { FanthonContext } from '../contexts/FanthonContext';

function useFanthon() {
  const context = useContext(FanthonContext);
  if (!context) {
    throw new Error('Fanthon context should be used within FanthonContextProvider');
  }
  return context;
};

export default useFanthon;